import { render, staticRenderFns } from "./ChargesView.vue?vue&type=template&id=70a07368&"
import script from "./ChargesView.vue?vue&type=script&lang=js&"
export * from "./ChargesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports